import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import ProductAll from "../components/ProductList/ProductAll";
import CategoriesShop from "../components/ProductList/CategoriesShop";
import ReactPaginate from "react-paginate";
import SliderProduct from "../components/Slide/SliderProduct";
import RingLoader from "react-spinners/RingLoader";
import baseUrl from "../url/baseUrl";
import "./Products.css";

// component hiển thị trang danh sách các sản phẩm
const ProductsPage = () => {
  const location = useLocation();
  const [products, setProducts] = useState([]);
  const [category, setCategory] = useState("Tất cả");
  const [selectedRanges, setSelectedRanges] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    document.title = "Sản Phẩm";
  }, []);

  useEffect(() => {
    setLoading(true);
    async function fetchProductData() {
      try {
        const response = await fetch(baseUrl + "/all-products");

        if (response.status === 404) {
          throw new Error("Can't find product!");
        }

        if (response.status !== 200) {
          throw new Error("Có lỗi sảy ra với server! ");
        }
        setError(null);
        const productItem = await response.json();
        setLoading(false);
        setProducts(productItem);
      } catch (err) {
        setLoading(false);
        setError(err.message);
      }
    }

    fetchProductData();
  }, []);

  const filterhandler = (prodName) => {
    setCategory(prodName);
  };

  const handleRangeChange = (range) => {
    setSelectedRanges((prevSelectedRanges) => {
      if (prevSelectedRanges.includes(range)) {
        return prevSelectedRanges.filter((r) => r !== range);
      } else {
        return [...prevSelectedRanges, range];
      }
    });
  };

  let filterProducts = products;
  // xét trường hợp nhận thông tin từ trang chủ (click từ ProductsListHome component ở trang chủ)
  if (location.state && location.state.category) {
    filterProducts = products.filter(
      (prod) => prod.category === location.state.category
    );
  }
  //lọc sp khi click từ thanh category
  if (category !== "Tất cả") {
    filterProducts = products.filter((prod) => prod.category === category);
  }

  filterProducts = filterProducts.filter((product) => {
    return (
      selectedRanges.length === 0 ||
      selectedRanges.some((range) => {
        return product.price >= range.min && product.price < range.max;
      })
    );
  });

  // Paginate
  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };

  const itemsPerPage = 12;
  const displayedItems = filterProducts.slice(
    currentPage * itemsPerPage,
    (currentPage + 1) * itemsPerPage
  );

  return (
    <section>
      <SliderProduct />

      <nav aria-label="breadcrumb">
        <ol
          style={{ "--bs-breadcrumb-bg": "#f0f0f0" }}
          className="breadcrumb  ps-3 pt-2 pb-3 mb-0 "
        >
          <li className="breadcrumb-item">
            <Link to="/">Trang chủ</Link>
          </li>
          <li className="breadcrumb-item">
            <Link to="/products">Danh mục</Link>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            {category === "Tất cả" ? "Tất cả sản phẩm" : category}
          </li>
        </ol>
      </nav>

      {error && <p style={{ color: "red", textAlign: "center" }}>{error}</p>}

      {/* show category and products */}
      <div className="container">
        <div className="row g-3">
          <div className="col-12 col-sm-6 col-md-4 col-lg-3">
            <CategoriesShop
              onFilter={filterhandler}
              onChange={handleRangeChange}
            />
          </div>

          <div className="col-12 col-sm-6 col-md-8 col-lg-9">
            {/* show spinner first */}
            {loading && (
              <div className="d-flex justify-content-center align-items-center mt-4">
                <RingLoader color="#36d7b7" size={80} />
              </div>
            )}
            {products.length !== 0 && (
              <ProductAll productShow={displayedItems} />
            )}
          </div>
        </div>
      </div>

      {/* paginate*/}
      <ReactPaginate
        breakLabel="..."
        previousLabel={"< Previous"}
        nextLabel={"Next >"}
        pageCount={Math.ceil(filterProducts.length / itemsPerPage)}
        onPageChange={handlePageChange}
        containerClassName={"pagination"}
        activeClassName={"active"}
        marginPagesDisplayed={2}
        pageRangeDisplayed={3}
      />
    </section>
  );
};
export default ProductsPage;
